import React from 'react'
import { WHITE } from '../../theme'
import styles from '../../styles'
import { AutresElementsCrossSellingModel } from './types/autresElementsCrossSellingModel'
import SwiperMobileAvecFleches from './SwiperMobileAvecFleches'
import CrossSellingCardsContent from './components/CrossSellingCardsContent'
import { makeStyles } from 'tss-react/mui'
import { Grid } from '@mui/material'

const useStyles = makeStyles<{ photosWidth: number | string, photosHeight: number | string }>()(
	(theme, { photosWidth, photosHeight }) =>
		({
			...styles(theme),
			autreElementCrossSellingCard: {
				background: WHITE,
				borderRadius: 30
			},
			autreElementCrossSellingCardContent: {
				padding: '22px 20px 19px'
			},
			photoContainer: {
				maxWidth: '100%',
				width: photosWidth,
				height: photosHeight,
				position: 'relative',
				marginBottom: 16
			},
			tagStyle: {
				position: 'absolute',
				left: 15,
				height: 23,
				borderRadius: 21,
				textTransform: 'uppercase',
				padding: '6px 10px',
				...styles(theme).text23,
				color: WHITE,
				boxSizing: 'border-box',
				zIndex: 1
			},
			heart: {
				position: 'absolute',
				right: 14,
				top: 17,
				borderRadius: 25,
				padding: 0,
				height: 20,
				zIndex: 1,
				width: 17
			}
		})
)

interface AcceptingProps {
	photoClassName?: string,
	elementCrossSelling: AutresElementsCrossSellingModel,
	showFavorite?: boolean
}

type AutreElementCrossSellingCardProps = AcceptingProps

const AutreElementCrossSellingCard: React.FC<AutreElementCrossSellingCardProps> = (
	{
		photoClassName,
		elementCrossSelling,
		showFavorite = false
	}
) => {
	const { classes, cx } = useStyles({
		photosWidth: elementCrossSelling.photosWidth,
		photosHeight: elementCrossSelling.photosHeight
	})

	return <Grid container className={classes.autreElementCrossSellingCard}>
		<Grid container item className={classes.autreElementCrossSellingCardContent} direction="column">
			<Grid
				container
				item
				className={
					cx(
						classes.photoContainer,
						photoClassName
					)
				}
			>
				<SwiperMobileAvecFleches photos={elementCrossSelling.photosMobiles ?? []} />

				{
					// Listing des tags si définis (présent sur la page du détail de l'offre)
					(elementCrossSelling.tags || []).map(
						(tag, index) => (
							<div
								className={classes.tagStyle}
								style={{
									backgroundColor: tag.couleur,
									// La distance dépend du nombre de tag déjà affiché (d'une hauteur de 23px) + la marge initiale du premier élément + la marge entre chaque tag
									top: (23 * index) + 15 + (index > 0 ? index * 10 : 0)
								}}
								key={`tag-${tag.libelle}-${index}`}
							>
								{tag.libelle}
							</div>
						)
					)
				}
			</Grid>
			<CrossSellingCardsContent elementCrossSelling={elementCrossSelling} />
		</Grid>
	</Grid>
}

export default AutreElementCrossSellingCard